import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

interface Hotel {
  name: string;
  url: string;
  text: string[];
}

export default function Lodging() {
  const hotels: Hotel[] = [
    {
      name: 'Tugboat Inn',
      url: 'https://www.tugboatinn.com/',
      text: ['Within walking distance to venue (5 min)', '$220 - $260/night'],
    },
    {
      name: "Fisherman's Wharf Inn",
      url: 'https://www.fishermanswharfinn.com/',
      text: [
        'Within walking distance to the venue (7 - 8 min)',
        '$250 - $350/night',
      ],
    },
    {
      name: 'Topside Inn',
      url: 'https://www.topsideinn.com/',
      text: [
        'Within walking distance to the venue (5 min)',
        'Bed and breakfast',
        '$500 - $600/night',
      ],
    },
    {
      name: 'Cottage Connection',
      url: 'https://www.cottageconnection.com/property-groups/southport-maine/',
      text: ['Small houses for rent'],
    },
    {
      name: "Captain Sawyer's Bed and Breakfast",
      url: 'https://www.captainsawyersboothbay.com/',
      text: ['Within walking distance of venue (5 min)', '$260 - $350/night'],
    },
    {
      name: "Brown's Wharf",
      url: 'https://www.brownswharfinn.com/',
      text: [
        'Across the harbor, but very walkable (20 min walk)',
        '$230 - $260/night',
      ],
    },
    {
      name: 'Harbor House Inn',
      url: 'https://www.harborhouse-me.com/',
      text: [
        'In town, within walking distance (10 - 15 min walk)',
        'Bed and Breakfast',
        'Special package deals if reserved by April 2025',
      ],
    },
    {
      name: 'Harbor Towne Inn',
      url: 'https://www.harbourtowneinn.com/',
      text: [
        'In town, within walking distance (10 - 15 min walk)',
        'Bed and Breakfast',
      ],
    },
  ];

  return (
    <SectionContainer containerId={'lodging'}>
      <SectionTitle title={'lodging'} />
      <SectionBody>
        <p className='section-text'>
          We'll be having the wedding at the{' '}
          <a
            className='text-blue-400 hover:underline'
            href='https://www.boothbayharbor.com/live/events-at-the-shipyard-in-boothbay-harbor/'
          >
            Bristol Marine Shipyard
          </a>{' '}
          in Boothbay Harbor, Maine on September 20, 2025!
        </p>
        <p className='section-text'>
          Here are some hotel possibilities for that weekend:
        </p>
        <div className='flex-1 flex flex-row flex-wrap w-full justify-center gap-4 section-text mt-4'>
          {hotels.map((hotel, idx) => (
            <div
              key={idx}
              className='flex flex-col px-4 pb-4 pt-3 w-[350px] border rounded-md shadow-sm gap-2'
            >
              <a className='text-blue-400 hover:underline' href={hotel.url}>
                {hotel.name}
              </a>
              {hotel.text.map((line, lineIdx) => (
                <p key={lineIdx} className='text-sm text-sub'>
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </SectionBody>
    </SectionContainer>
  );
}
//  talk about dress code and food here too
